import styled, { css } from 'styled-components';
import { Colors, Breakpoints } from 'styles/Constants';

export interface StyledTooltipWrapperProps {
  visible: boolean;
}

export const FilterCampaigns = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;

  button {
    border-radius: 20px;
    font-size: 0.6875rem;
    padding: 6px 15px;
    height: 35px;
    margin-right: 20px;
  }

  input {
    width: 30%;
    margin-right: 20px;

    @media (max-width: ${Breakpoints.medium}) {
      width: 100%;
      margin-right: 0;
    }
  }

  span {
    margin-top: 7px;

    @media (max-width: ${Breakpoints.medium}) {
      margin-top: 10px;
    }
  }

  .filter-group {
    display: inline-flex;
  }

  @media (max-width: ${Breakpoints.medium}) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;

    > * {
      margin-right: 0 !important;
    }

    /* Grupo para span y dropdowns en horizontal */
    .filter-group {
      display: inline-flex;
      align-items: center;
      gap: 15px;
      flex-wrap: wrap;

      span {
        white-space: nowrap;
        margin-bottom: 0;
      }

      /* Ajustar el ancho de los dropdowns en móvil */
      .dropdown-select {
        flex: 1;
        min-width: 120px;
      }
    }
  }
`;

export const StyleTable = styled.div`
  .column {
    background-color: ${Colors.normalWhite};
    position: relative;
    font-weight: 500;
    font-size: 14px;
    color: ${Colors.secondaryNormalGrey};
    border: none;
    font-weight: bold;
  }

  .table {
    border-collapse: separate;
    border-spacing: 0 20px;
    font-size: 1rem;
    color: ${Colors.secondaryNormalGrey};
    margin-bottom: 10px;
    max-width: 100%;
    width: 100%;
    border-radius: 4px;
    box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 0%), 0px 0px 0px 0px rgb(0 0 0 / 0%),
      0px 0px 0px 0px rgb(0 0 0 / 0%);

    @media (max-width: ${Breakpoints.medium}) {
      display: none;
    }
  }

  .responsive-table {
    display: none;

    @media (max-width: ${Breakpoints.medium}) {
      display: block;
      width: 100%;
    }
  }

  .table_container {
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 4px;
    box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 0%), 0px 0px 0px 0px rgb(0 0 0 / 0%),
      0px 0px 0px 0px rgb(0 0 0 / 0%);

    @media (max-width: ${Breakpoints.medium}) {
      display: none;
    }
  }

  .column-body {
    box-shadow: 0 1px 6px 0 rgb(79 79 79 / 38%);
    transition: all 0.5s ease-out 0s;
    background: ${Colors.normalWhite};
    margin-bottom: 20px;
    border-radius: 10px;
    z-index: 2;
    height: 70px;

    &.pending-bg {
      background-color: #c7e6eb;
    }

    th {
      font-family: 'Montserrat', sans-serif;
      font-size: 1.125rem;
      padding: 16px;
      border-collapse: separate;
      border-spacing: 0 20px;
      font-size: 1rem;
      color: ${Colors.secondaryNormalGrey};
      border-bottom: none;
    }

    img {
      height: 20px;
      width: 20px;
    }

    svg {
      height: 22px;
      width: 22px;
    }

    img.user-photo {
      border-radius: 100%;
      margin: 0 10px;
      height: 50px;
      width: 50px;
    }
  }

  .name {
    font-weight: 700;
    text-align: left;
  }

  .social-network {
    margin: auto;
  }

  .date {
    text-transform: capitalize;
    font-weight: 700;
  }

  .pointer {
    cursor: pointer;
  }
`;

export const HeardMargin = styled.div`
  display: block;
  align-items: center;
  flex-wrap: nowrap;

  .option {
    display: inline-flex;
    margin-right: 10px;
    align-items: center;
    img {
      margin-right: 10px;
      height: 20px;
      width: 20px;
    }

    svg {
      margin-right: 10px;
      height: 22px;
      width: 22px;
    }
  }

  @media (max-width: ${Breakpoints.medium}) {
    margin-top: 15px;
    margin-bottom: 15px;
    gap: 10px;
    flex-wrap: wrap;
    .option {
      img,
      svg {
        margin-top: 0;
      }
    }
  }
`;

export const TextStyled = styled.p`
  margin-right: 10px;
  font-weight: 500;
  font-size: 14px;
  color: ${Colors.secondaryNormalGrey};

  @media (max-width: ${Breakpoints.medium}) {
    font-size: 13px;
  }
`;

// ===== NUEVA TABLA RESPONSIVE COMPACTA =====

export const CompactTable = styled.div`
  display: none;
  padding: 0px;
  @media (max-width: ${Breakpoints.medium}) {
    display: block;
    width: 100%;
    overflow-x: auto;
  }
`;

export const CompactTableHeader = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr 80px 60px;
  gap: 8px;
  padding: 12px 8px;
  color: #000;
  font-weight: 600;
  font-size: 12px;
  border-radius: 8px 8px 0 0;
  align-items: center;

  .header-item {
    text-align: center;
    padding: 4px;

    &:nth-child(2) {
      text-align: left;
    }
  }
`;

export const CompactTableRow = styled.div<{ status?: string }>`
  display: grid;
  grid-template-columns: 60px 1fr 80px 60px;
  gap: 8px;
  background: ${Colors.normalWhite};
  align-items: center;
  box-shadow: 0 1px 6px 0 rgb(79 79 79 / 38%);
  transition: all 0.5s ease-out 0s;
  margin-bottom: 20px;
  border-radius: 10px;
  z-index: 2;
  height: 100px;

  ${({ status }) =>
    status === 'pending' &&
    css`
      background-color: #f0f9ff;
    `}

  &:hover {
    background-color: ${Colors.lightBlue};
  }

  &:last-child {
    border-bottom: none;
    border-radius: 0 0 8px 8px;
  }
`;

export const CompactTableCell = styled.div<{ align?: string }>`
  text-align: ${props => props.align || 'center'};
  font-size: 13px;
  padding: 4px;

  &.user-cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  &.actions-cell {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
`;

export const UserAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0 auto;
  display: block;
`;

export const UserInfo = styled.div`
  text-align: left;

  .user-reference {
    font-weight: 700;
    font-size: 13px;
    color: ${Colors.primaryText};
    margin-bottom: 2px;
  }

  .user-date {
    font-size: 11px;
    color: ${Colors.secondaryText};
  }
`;

export const StatusBadge = styled.div<{ status: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;

  ${({ status }) => {
    switch (status) {
      case 'approved':
        return css`
          color: #2e7d32;
        `;
      case 'pending':
        return css`
          color: #f57c00;
        `;
      case 'rejected':
        return css`
          color: red;
        `;
      default:
        return css`
          color: #666;
        `;
    }
  }}
`;

export const ActionIcons = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;

  img {
    width: 18px;
    height: 18px;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const PointsDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-weight: 700;
  color: ${Colors.primaryDarkBlue};

  .points-icon {
    width: 14px;
    height: 14px;
  }
`;

export const SocialIconCompact = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 5px;
  .social-icon {
    width: 24px;
    height: 24px;
  }
`;

export const TooltipMessage = styled.span`
  visibility: hidden;
  display: none;
  background-color: #1661ea;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 2;
  bottom: 100%;
  left: 0px;
  margin-left: 0px;
  transition: opacity 0.3s;
  margin-bottom: 10px;

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 20%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #1661ea transparent transparent transparent;
  }
`;

export const StyledTooltipWrapper = styled.div<StyledTooltipWrapperProps>`
  position: relative;
  cursor: pointer;

  ${({ visible }) =>
    visible &&
    css`
      ${TooltipMessage} {
        visibility: visible;
        display: block;
      }
      ${TooltipMessage}.ranking-tooltip {
        visibility: visible;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        min-width: 300px;
        left: inherit !important;
      }
    `}
`;

export const SocialInfoStyled = styled.div`
  &.total-points {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    height: 20px;
    width: 20px;

    &.points {
      height: 15px;
      width: 15px;
      margin-left: 5px;
    }
  }

  b {
    font-size: 16px;
    line-height: 23px;
    margin: 7px 0 0 7px;
  }
`;

// ===== NUEVOS ESTILOS RESPONSIVE PARA MOBILE =====

export const MobileBonusCard = styled.div`
  display: none;

  @media (max-width: ${Breakpoints.medium}) {
    display: block;
    background: ${Colors.normalWhite};
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid ${Colors.lightGray};
  }
`;

export const MobileCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;

  .mobile-user-photo {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 12px;
    object-fit: cover;
  }

  .mobile-user-info {
    flex: 1;

    .mobile-reference {
      font-weight: 700;
      font-size: 16px;
      color: ${Colors.primaryText};
      margin-bottom: 4px;
    }

    .mobile-dates {
      font-size: 12px;
      color: ${Colors.secondaryText};
    }
  }

  .mobile-status {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const MobileCardContent = styled.div`
  .mobile-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid ${Colors.lightGray};

    &:last-child {
      border-bottom: none;
    }

    .mobile-label {
      font-weight: 600;
      color: ${Colors.primaryText};
      font-size: 14px;
    }

    .mobile-value {
      font-size: 14px;
      color: ${Colors.secondaryText};
      text-align: right;
    }

    .mobile-social {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .mobile-actions {
      display: flex;
      gap: 12px;
      align-items: center;
    }
  }
`;

export const MobilePoints = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  .points-value {
    font-weight: 700;
    font-size: 16px;
  }

  .points-icon {
    width: 16px;
    height: 16px;
  }
`;

export const MobilePagination = styled.div`
  @media (max-width: ${Breakpoints.medium}) {
    .MuiTablePagination-toolbar {
      flex-direction: row;
      gap: 10px;
    }

    .MuiTablePagination-spacer {
      display: none;
    }

    .MuiTablePagination-actions {
      margin-left: 0;
    }
  }
`;

export const MarginAmbassadorPage = styled.div`
  display: flex;
  justify-content: space-between;

  button {
    margin-left: 60%;
    font-size: 1.125rem;
    height: 20%;
    margin-bottom: 30px;
    border: 1px solid #d113fe;
    background-color: #d113fe;
  }

  @media (max-width: ${Breakpoints.medium}) {
    flex-direction: column;
    gap: 15px;

    button {
      margin-left: 0;
      width: 100%;
    }
  }
`;

export const PostDetailWrapper = styled.div`
  p.small-paragraph {
    font-size: 0.875rem;
    text-align: center;
    margin: 0 0 5px 0;
    font-weight: 500;
  }

  a {
    width: 90%;
  }
`;

export const SocialButtton = styled.button`
  background: none;
  border: none;
  zoom: 150%;
  filter: grayscale(1);
  cursor: pointer;

  &.selected {
    filter: grayscale(0);
    zoom: 200%;
  }
`;
